import { css } from 'styled-components';

export const averta = '\'Averta\', \'Helvetica Neue\', Helvetica, Arial, sans-serif';

export const loadAverta = () => css`
  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/light.woff') format('woff'),
        url('/static/myfs/font/averta/light.eot') format('eot'),
        url('/static/myfs/font/averta/light.ttf') format('truetype'),
        url('/static/myfs/font/averta/light.woff2') format('woff2');
    font-weight: 300;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/lightitalic.woff') format('woff'),
        url('/static/myfs/font/averta/lightitalic.eot') format('eot'),
        url('/static/myfs/font/averta/lightitalic.ttf') format('truetype'),
        url('/static/myfs/font/averta/lightitalic.woff2') format('woff2');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/regular.woff') format('woff'),
        url('/static/myfs/font/averta/regular.eot') format('eot'),
        url('/static/myfs/font/averta/regular.ttf') format('truetype'),
        url('/static/myfs/font/averta/regular.woff2') format('woff2');
    font-weight: 400;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/regularitalic.woff') format('woff'),
        url('/static/myfs/font/averta/regularitalic.eot') format('eot'),
        url('/static/myfs/font/averta/regularitalic.ttf') format('truetype'),
        url('/static/myfs/font/averta/regularitalic.woff2') format('woff2');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/semibold.woff') format('woff'),
        url('/static/myfs/font/averta/semibold.eot') format('eot'),
        url('/static/myfs/font/averta/semibold.ttf') format('truetype'),
        url('/static/myfs/font/averta/semibold.woff2') format('woff2');
    font-weight: 600;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/semibolditalic.woff') format('woff'),
        url('/static/myfs/font/averta/semibolditalic.eot') format('eot'),
        url('/static/myfs/font/averta/semibolditalic.ttf') format('truetype'),
        url('/static/myfs/font/averta/semibolditalic.woff2') format('woff2');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/bold.woff') format('woff'),
        url('/static/myfs/font/averta/bold.eot') format('eot'),
        url('/static/myfs/font/averta/bold.ttf') format('truetype'),
        url('/static/myfs/font/averta/bold.woff2') format('woff2');
    font-weight: 700;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/bolditalic.woff') format('woff'),
        url('/static/myfs/font/averta/bolditalic.eot') format('eot'),
        url('/static/myfs/font/averta/bolditalic.ttf') format('truetype'),
        url('/static/myfs/font/averta/bolditalic.woff2') format('woff2');
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/black.woff') format('woff'),
        url('/static/myfs/font/averta/black.eot') format('eot'),
        url('/static/myfs/font/averta/black.ttf') format('truetype'),
        url('/static/myfs/font/averta/black.woff2') format('woff2');
    font-weight: 800;
  }

  @font-face {
    font-family: 'Averta';
    src: url('/static/myfs/font/averta/blackitalic.woff') format('woff'),
        url('/static/myfs/font/averta/blackitalic.eot') format('eot'),
        url('/static/myfs/font/averta/blackitalic.ttf') format('truetype'),
        url('/static/myfs/font/averta/blackitalic.woff2') format('woff2');
    font-weight: 800;
    font-style: italic;
  }
`;
